module.exports = __webpack_public_path__ + "static/img/22.d38d35c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/22.jpg
// module id = yi+K
// module chunks = 1